import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-end" }
const _hoisted_2 = { class: "absolute right-0 z-20 bg-white top-0 min-h-screen p-5 py-3 shadow w-64" }
const _hoisted_3 = { class: "flex h-16 justify-between" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 235.66 71.72\" width=\"110\" height=\"34\" class=\"m-2 mb-4\"><defs></defs><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M189.51,15.42a12.49,12.49,0,0,0-8,3.22,5.18,5.18,0,0,0-5.16-3.22c-3.2,0-5.44,2-5.44,5V50.1c0,2.92,2.24,5,5.44,5s5.45-2,5.45-5V33.39c-.07-4.48,2.6-7.37,7.52-8.15,3.94-.66,5.94-2.34,5.94-5S192.86,15.42,189.51,15.42Z\"></path><path class=\"cls-1\" d=\"M108.64,5V18a17.36,17.36,0,0,0-9.43-2.57A19.35,19.35,0,0,0,79.46,35.24c0,11.49,8.45,19.82,20.08,19.82,4.07,0,7.23-.84,9.66-2.61a5.31,5.31,0,0,0,4.89,2.61c3.21,0,5.45-2,5.45-5V5c0-2.92-2.24-5-5.45-5S108.64,2,108.64,5ZM99.88,46.34c-5.88,0-9.52-4.25-9.52-11.1s3.7-11.09,9.43-11.09,9.52,4.28,9.52,11.16C109.31,42,105.61,46.34,99.88,46.34Z\"></path><path class=\"cls-1\" d=\"M215.41,55.06A16.18,16.18,0,0,0,225.49,52a5.05,5.05,0,0,0,4.89,3.09c3,0,5.28-2,5.28-4.74V20.17c0-2.7-2.27-4.75-5.28-4.75a5.09,5.09,0,0,0-4.85,3,16.7,16.7,0,0,0-10-3c-11.79,0-20.34,8.34-20.34,19.82C195.16,46.54,203.87,55.06,215.41,55.06Zm.17-30.91c5.87,0,9.52,4.25,9.52,11.09s-3.65,11.1-9.52,11.1-9.52-4.28-9.52-11.17C206.06,28.47,209.8,24.15,215.58,24.15Z\"></path><path class=\"cls-1\" d=\"M165.78,34.26c0-10.56-8.85-18.84-20.16-18.84-12,0-20.67,8.4-20.67,20,0,11.78,8.41,19.68,20.92,19.68,7.68,0,19.07-3.85,19.07-9.18a4.44,4.44,0,0,0-4.44-4.33c-1.39,0-2.46.54-4.19,1.69a15.9,15.9,0,0,1-9.93,3.1A11.31,11.31,0,0,1,138.8,44a7.32,7.32,0,0,1-2.72-4.64h23.84C163.86,39.36,165.78,37.69,165.78,34.26Zm-29.67-3c1-4.85,3.92-7.12,9.17-7.12s8.49,2.51,9.38,7.12Z\"></path><path class=\"cls-1\" d=\"M76,34.26c0-10.56-8.86-18.84-20.16-18.84-12,0-20.67,8.4-20.67,20,0,11.78,8.41,19.68,20.92,19.68,7.68,0,19.07-3.85,19.07-9.18a4.44,4.44,0,0,0-4.44-4.33c-1.4,0-2.46.54-4.2,1.69a15.86,15.86,0,0,1-9.93,3.1A11.3,11.3,0,0,1,49,44a7.32,7.32,0,0,1-2.72-4.64H70.11C74.06,39.36,76,37.69,76,34.26Zm-29.67-3c1-4.85,3.92-7.12,9.17-7.12s8.48,2.51,9.38,7.12Z\"></path><path class=\"cls-1\" d=\"M19.32,55.06c3.21,0,5.45-2,5.45-5v-37h8.51c3.21,0,5.37-1.85,5.37-4.61s-2.16-4.54-5.37-4.54H5.36C2.16,3.94,0,5.77,0,8.48s2.16,4.61,5.36,4.61h8.52v37C13.88,53,16.12,55.06,19.32,55.06Z\"></path><path class=\"cls-2\" d=\"M189.2,59.77a1.5,1.5,0,0,0-1.48-1.12,1.54,1.54,0,0,0-1.49,1.12L182,69.91a2.81,2.81,0,0,0-.24.88,1,1,0,0,0,1.12.93A1.11,1.11,0,0,0,184,71l.81-2h5.88l.8,2a1.1,1.1,0,0,0,1.1.77,1,1,0,0,0,1.1-.93,1.66,1.66,0,0,0-.14-.6Zm.7,7.26h-4.36l2.18-5.54Z\"></path><path class=\"cls-2\" d=\"M202.54,57.73a1.06,1.06,0,0,0-1.14,1.11V62.6a3.76,3.76,0,0,0-2.47-.85,5,5,0,0,0,.08,10,3.31,3.31,0,0,0,2.42-.81,1.15,1.15,0,0,0,2.25-.31V58.84A1.07,1.07,0,0,0,202.54,57.73Zm-1,9c0,1.85-1,3-2.47,3s-2.48-1.18-2.48-3.07,1-3.07,2.46-3.07S201.56,64.84,201.56,66.75Z\"></path><path class=\"cls-2\" d=\"M216.4,61.75a3.7,3.7,0,0,0-3.06,1.37,3.31,3.31,0,0,0-2.83-1.37,3.25,3.25,0,0,0-2.31.77,1.15,1.15,0,0,0-2.24.34V70.6a1.14,1.14,0,0,0,2.28,0V65.48a1.87,1.87,0,0,1,3.73,0V70.6a1.15,1.15,0,0,0,2.29,0V65.48a1.67,1.67,0,0,1,1.85-1.82A1.69,1.69,0,0,1,218,65.48V70.6a1.14,1.14,0,0,0,2.28,0V65.52A3.58,3.58,0,0,0,216.4,61.75Z\"></path><path class=\"cls-2\" d=\"M223.63,61.75a1.06,1.06,0,0,0-1.14,1.11V70.6a1.15,1.15,0,0,0,2.29,0V62.86A1.07,1.07,0,0,0,223.63,61.75Z\"></path><path class=\"cls-2\" d=\"M223.63,58.65A1.24,1.24,0,1,0,225,59.89,1.28,1.28,0,0,0,223.63,58.65Z\"></path><path class=\"cls-2\" d=\"M231.81,61.75a3.85,3.85,0,0,0-2.55.87,1.15,1.15,0,0,0-2.26.24V70.6a1.14,1.14,0,0,0,2.28,0v-5a2.05,2.05,0,0,1,4.1,0v5a1.14,1.14,0,0,0,2.28,0V65.52A3.61,3.61,0,0,0,231.81,61.75Z\"></path></g></g></svg>", 1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 11L11 1",
  stroke: "#222B45",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 1L11 11",
  stroke: "#222B45",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.0732 1.63625L2.1432 7.18624C1.3632 7.80624 0.863195 9.11627 1.03319 10.0963L2.3632 18.0562C2.6032 19.4762 3.96319 20.6262 5.40319 20.6262H16.6032C18.0332 20.6262 19.4032 19.4662 19.6432 18.0562L20.9732 10.0963C21.1332 9.11627 20.6332 7.80624 19.8632 7.18624L12.9332 1.64626C11.8632 0.78626 10.1332 0.786251 9.0732 1.63625Z",
    stroke: "#ed5151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "Dashboard", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.01367 10.2202V14.7102C2.01367 19.2002 3.81367 21.0002 8.30367 21.0002H13.6937C18.1837 21.0002 19.9837 19.2002 19.9837 14.7102V10.2202\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.0044 11C12.8344 11 14.1844 9.51 14.0044 7.68L13.3444 1H8.67438L8.00438 7.68C7.82438 9.51 9.17438 11 11.0044 11Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.3147 11C19.3347 11 20.8147 9.36 20.6147 7.35L20.3347 4.6C19.9747 2 18.9747 1 16.3547 1H13.3047L14.0047 8.01C14.1747 9.66 15.6647 11 17.3147 11Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.64428 11C6.29428 11 7.78428 9.66 7.94428 8.01L8.16428 5.8L8.64428 1H5.59428C2.97428 1 1.97428 2 1.61428 4.6L1.34428 7.35C1.14428 9.36 2.62428 11 4.64428 11Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.0039 16C9.33391 16 8.50391 16.83 8.50391 18.5V21H13.5039V18.5C13.5039 16.83 12.6739 16 11.0039 16Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><span class=\"flex-1 ml-3 whitespace-nowrap\">Stores</span>", 2)
const _hoisted_14 = [
  _hoisted_12
]
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.50391 6.66171V5.69171C5.50391 3.44171 7.31391 1.23171 9.56391 1.02171C12.2439 0.761708 14.5039 2.87171 14.5039 5.50171V6.88171\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.00471 20.9917H13.0047C17.0247 20.9917 17.7447 19.3817 17.9547 17.4217L18.7047 11.4217C18.9747 8.9817 18.2747 6.9917 14.0047 6.9917H6.00471C1.73471 6.9917 1.03471 8.9817 1.30471 11.4217L2.05471 17.4217C2.26471 19.3817 2.98471 20.9917 7.00471 20.9917Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M13.4984 10.9917H13.5074\" stroke=\"#515151\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M6.49841 10.9917H6.5074\" stroke=\"#515151\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><span class=\"flex-1 ml-3 whitespace-nowrap\">Orders</span><span class=\"button-notification-count\">3</span>", 3)
const _hoisted_18 = [
  _hoisted_15
]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 22 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.0039 6.5H6.00391\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21.0041 8.47015V10.5302C21.0041 11.0802 20.5641 11.5302 20.0041 11.5502H18.0441C16.9641 11.5502 15.9741 10.7602 15.8841 9.68018C15.8241 9.05018 16.0641 8.46017 16.4841 8.05017C16.8541 7.67017 17.3641 7.4502 17.9241 7.4502H20.0041C20.5641 7.4702 21.0041 7.92015 21.0041 8.47015Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.4839 8.04999C16.0639 8.45999 15.8239 9.04999 15.8839 9.67999C15.9739 10.76 16.9639 11.55 18.0439 11.55H20.0039V13C20.0039 16 18.0039 18 15.0039 18H6.00391C3.00391 18 1.00391 16 1.00391 13V6C1.00391 3.28 2.64391 1.38 5.19391 1.06C5.45391 1.02 5.72391 1 6.00391 1H15.0039C15.2639 1 15.5139 1.00999 15.7539 1.04999C18.3339 1.34999 20.0039 3.26 20.0039 6V7.45001H17.9239C17.3639 7.45001 16.8539 7.66999 16.4839 8.04999Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><span class=\"flex-1 ml-3 whitespace-nowrap\">Finance</span>", 2)
const _hoisted_21 = [
  _hoisted_19
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 22 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5039 9.5C18.5039 8.12 19.6239 7 21.0039 7V6C21.0039 2 20.0039 1 16.0039 1H6.00391C2.00391 1 1.00391 2 1.00391 6V6.5C2.38391 6.5 3.50391 7.62 3.50391 9C3.50391 10.38 2.38391 11.5 1.00391 11.5V12C1.00391 16 2.00391 17 6.00391 17H16.0039C20.0039 17 21.0039 16 21.0039 12C19.6239 12 18.5039 10.88 18.5039 9.5Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.00391 1L9.00391 17",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-dasharray": "5 5"
  })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "Coupons", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "border-gray-200 border-t mt-4 pt-4 space-y-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "button-nav-admin" }, "Admin")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0039 11C12.7653 11 15.0039 8.76142 15.0039 6C15.0039 3.23858 12.7653 1 10.0039 1C7.24248 1 5.00391 3.23858 5.00391 6C5.00391 8.76142 7.24248 11 10.0039 11Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5941 21C18.5941 17.13 14.7441 14 10.0041 14C5.26406 14 1.41406 17.13 1.41406 21",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "Users", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 22 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.30391 13H9.70391C11.7039 13 12.5039 12.2 12.5039 10.2V7.8C12.5039 5.8 11.7039 5 9.70391 5H7.30391C5.30391 5 4.50391 5.8 4.50391 7.8V10.2C4.50391 12.2 5.30391 13 7.30391 13Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.0039 17H6.00391C2.00391 17 1.00391 16 1.00391 12V6C1.00391 2 2.00391 1 6.00391 1H16.0039C20.0039 1 21.0039 2 21.0039 6V12C21.0039 16 20.0039 17 16.0039 17Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "Sliders", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.0039 16V18.38C11.0039 20.25 10.2539 21 8.37391 21H3.62391C1.75391 21 1.00391 20.25 1.00391 18.38V13.63C1.00391 11.75 1.75391 11 3.62391 11H6.00391V13.37C6.00391 15.25 6.75391 16 8.62391 16H11.0039Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.0039 11V13.37C16.0039 15.25 15.2539 16 13.3739 16H8.62391C6.75391 16 6.00391 15.25 6.00391 13.37V8.62C6.00391 6.75 6.75391 6 8.62391 6H11.0039V8.37C11.0039 10.25 11.7539 11 13.6239 11H16.0039Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.0039 3.62V8.37C21.0039 10.25 20.2539 11 18.3739 11H13.6239C11.7539 11 11.0039 10.25 11.0039 8.37V3.62C11.0039 1.75 11.7539 1 13.6239 1H18.3739C20.2539 1 21.0039 1.75 21.0039 3.62Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "Categories", -1)
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div><a href=\"push-notifications.html\" class=\"button-nav flex\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 22 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.00391 6C1.00391 2.5 3.00391 1 6.00391 1H16.0039C19.0039 1 21.0039 2.5 21.0039 6V13C21.0039 16.5 19.0039 18 16.0039 18H6.00391\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.0039 6.5L12.8739 9C11.8439 9.82 10.1539 9.82 9.1239 9L6.00391 6.5\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M1.00391 14H7.00391\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M1.00391 10H4.00391\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><span class=\"ml-3\">Push Notifications</span></a></div><div><a href=\"#\" class=\"button-nav flex\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 22 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.0039 13.439C12.6608 13.439 14.0039 12.0958 14.0039 10.439C14.0039 8.78211 12.6608 7.43896 11.0039 7.43896C9.34705 7.43896 8.00391 8.78211 8.00391 10.439C8.00391 12.0958 9.34705 13.439 11.0039 13.439Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M1.00391 11.3189V9.5589C1.00391 8.5189 1.85391 7.6589 2.90391 7.6589C4.71391 7.6589 5.45391 6.3789 4.54391 4.8089C4.02391 3.9089 4.33391 2.7389 5.24391 2.2189L6.97391 1.2289C7.76391 0.758901 8.78391 1.0389 9.25391 1.8289L9.36391 2.0189C10.2639 3.5889 11.7439 3.5889 12.6539 2.0189L12.7639 1.8289C13.2339 1.0389 14.2539 0.758901 15.0439 1.2289L16.7739 2.2189C17.6839 2.7389 17.9939 3.9089 17.4739 4.8089C16.5639 6.3789 17.3039 7.6589 19.1139 7.6589C20.1539 7.6589 21.0139 8.5089 21.0139 9.5589V11.3189C21.0139 12.3589 20.1639 13.2189 19.1139 13.2189C17.3039 13.2189 16.5639 14.4989 17.4739 16.0689C17.9939 16.9789 17.6839 18.1389 16.7739 18.6589L15.0439 19.6489C14.2539 20.1189 13.2339 19.8389 12.7639 19.0489L12.6539 18.8589C11.7539 17.2889 10.2739 17.2889 9.36391 18.8589L9.25391 19.0489C8.78391 19.8389 7.76391 20.1189 6.97391 19.6489L5.24391 18.6589C4.33391 18.1389 4.02391 16.9689 4.54391 16.0689C5.45391 14.4989 4.71391 13.2189 2.90391 13.2189C1.85391 13.2189 1.00391 12.3589 1.00391 11.3189Z\" stroke=\"#515151\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><span class=\"ml-3\">Settings</span></a></div><div></div>", 3)
const _hoisted_36 = { class: "border-gray-200 border-t mt-4 pt-4 space-y-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0039 11C12.7653 11 15.0039 8.76142 15.0039 6C15.0039 3.23858 12.7653 1 10.0039 1C7.24248 1 5.00391 3.23858 5.00391 6C5.00391 8.76142 7.24248 11 10.0039 11Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5941 21C18.5941 17.13 14.7441 14 10.0041 14C5.26406 14 1.41406 17.13 1.41406 21",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "Profile Settings", -1)
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 22 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.30391 13H9.70391C11.7039 13 12.5039 12.2 12.5039 10.2V7.8C12.5039 5.8 11.7039 5 9.70391 5H7.30391C5.30391 5 4.50391 5.8 4.50391 7.8V10.2C4.50391 12.2 5.30391 13 7.30391 13Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.0039 17H6.00391C2.00391 17 1.00391 16 1.00391 12V6C1.00391 2 2.00391 1 6.00391 1H16.0039C20.0039 1 21.0039 2 21.0039 6V12C21.0039 16 20.0039 17 16.0039 17Z",
    stroke: "#515151",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "Logout", -1)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _hoisted_4,
        (_openBlock(), _createElementBlock("svg", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
          class: "cursor-pointer",
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _hoisted_7))
      ]),
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/dashboard'))),
            class: "button-nav-active flex"
          }, _hoisted_11)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/stores'))),
            class: "button-nav flex"
          }, _hoisted_14)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/order'))),
            class: "button-nav flex"
          }, _hoisted_18)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/finance'))),
            class: "button-nav flex"
          }, _hoisted_21)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/coupon'))),
            class: "button-nav flex"
          }, _hoisted_24)
        ])
      ]),
      _createElementVNode("ul", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/users",
            class: "button-nav flex"
          }, {
            default: _withCtx(() => [
              _hoisted_27,
              _hoisted_28
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/sliders",
            class: "button-nav flex"
          }, {
            default: _withCtx(() => [
              _hoisted_29,
              _hoisted_30
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/categories",
            class: "button-nav flex"
          }, {
            default: _withCtx(() => [
              _hoisted_31,
              _hoisted_32
            ]),
            _: 1
          })
        ]),
        _hoisted_33
      ]),
      _createElementVNode("ul", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/profile'))),
            class: "button-nav flex"
          }, _hoisted_40)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
            class: "button-nav flex"
          }, _hoisted_43)
        ]),
        _hoisted_44
      ])
    ])
  ]))
}